import { getNavMenuContent } from '@hhgtech/hhg-components'
import {
  cleanUpUndefined,
  formatCategory,
  formatExpertUser,
  formatHealthTool,
} from 'api/dataTransform'
import { PATHS } from 'api/paths'
import { callApi, getApiPath } from 'api/utils'
import Component from 'container/categories/category/ExpertDetail.Page'
import { useGetIsMobile, useScreenSize } from 'hooks'
import { IExpertDetailPage } from 'interfaces/categories.interface'
import { GetServerSideProps } from 'next'
import { ROLE_USER_REGEX } from 'utils/contains'

const ExpertPage = (props: IExpertDetailPage) => {
  const { isMobileSsr } = props
  const { isMobile: isMobileCsr } = useScreenSize()

  const isMobile = useGetIsMobile(isMobileSsr, isMobileCsr)

  const componentProp: IExpertDetailPage = {
    isMobile,
    ...props,
  }
  return <Component {...componentProp} />
}

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const { query } = ctx
  const { slug } = query

  const finalSlug = Array.isArray(slug) ? slug[slug.length - 1] : slug

  const [
    expertRes,
    categoriesApi,
    healthTools,
    footer,
    navMenuContent,
  ] = await Promise.all([
    callApi(
      getApiPath(PATHS.GET_USER_INFO, {
        slug: finalSlug || '',
      }),
      'get',
    ),
    callApi(getApiPath(PATHS.GET_ALL_CATEGORIES), 'GET'),
    callApi(getApiPath(PATHS.GET_ALL_HEALTH_TOOLS), 'GET'),
    callApi(getApiPath(PATHS.GET_DYNAMIC_FOOTER), 'GET'),
    getNavMenuContent('vi-VN_MB'),
  ])

  if (expertRes && expertRes.status === 2 && expertRes.data?.redirect_url) {
    return {
      redirect: {
        destination: expertRes.data.redirect_url,
        permanent: true,
      },
    }
  }

  if (
    !expertRes ||
    expertRes.status !== 1 ||
    expertRes?.data?.turn_off_profile
  ) {
    return {
      notFound: true,
    }
  }

  const profileSlug = expertRes?.data?.profile_url || ''

  if (
    // ROLE_USER['2'].includes(profileSlug) &&
    ROLE_USER_REGEX[2].test(profileSlug) &&
    profileSlug
  ) {
    return {
      redirect: {
        destination: profileSlug,
        permanent: true,
      },
    }
  }

  return {
    props: {
      expert: formatExpertUser(expertRes.data),
      categories: categoriesApi?.data?.map(formatCategory) ?? [],
      healthTools:
        healthTools?.data && healthTools?.data.length > 0
          ? healthTools?.data?.map(formatHealthTool)
          : [],
      footerMenu: footer?.data ?? {},
      dataNavMenuContent: cleanUpUndefined(navMenuContent) || null,
    },
  }
}

export default ExpertPage
